import React from "react";
import { WorkflowSettings } from "../manage-workflows/workflow-settings";

export const AccountSettingsWorkflow: React.FC<unknown> = () => {
    return <WorkflowSettings scope="user" />;
};
